import { Grid, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  REPORTS_ANALYTICS_DASHBOARD_LIST,
  AI_DASHBOARD_PRIVILEGES,
} from "../../../constant/constant";
import { REPORT_DASHBOARD } from "../../../constant/routeContant";
import TabPanel from "../../lms/component/tabPanel/tabPanel";
import InspectionsContainer from "../inspections/container/inspectionsContainer";
import LmsContainer from "../lms/container/lmsContainer";
import IncidentsContainer from "../incidents/container/incidentsContainer";
import "./reportAnalytics.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../utils/rolesHelper";

const REPORT_DASHBOARD_TAB_INDEX = 3;

const ReportAnalytics = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // The AI-Dashboard tab used to render for everyone, so a user without a
  // dashboard privilege saw it, clicked it, and got bounced to /access-denied by
  // the page's own 401 guard. Gate it on the same privileges the backend
  // SafetyDashboard* action methods are mapped to (12 + the REPORT & ANALYTICS
  // triad) so the tab only appears when the API will actually answer.
  const canViewAiDashboard = checkPrivileges(AI_DASHBOARD_PRIVILEGES);

  function a11yProps(index, id) {
    return {
      id: `${id}`,
      "aria-controls": `${index}`,
    };
  }

  const [value, setValue] = useState(
    location?.state?.tab != null ? Number(location.state.tab) : 0,
  );

  useEffect(() => {
    if (location?.state?.tab != null) {
      setValue(Number(location.state.tab));
    }
  }, [location?.state?.tab]);

  const handleChange = (event, newValue) => {
    if (newValue === REPORT_DASHBOARD_TAB_INDEX) {
      // Guarded as well as hidden: location.state.tab can still carry index 3
      // from a stale history entry after a privilege change.
      if (canViewAiDashboard) {
        navigate(REPORT_DASHBOARD);
      }
      return;
    }
    setValue(newValue);
  };

  return (
    <>
      <Grid container>
        <Grid item md={12} xs={12}>
          <Tabs value={value} onChange={handleChange} className="tabsWrapper">
            {REPORTS_ANALYTICS_DASHBOARD_LIST?.map((tabItem, i) => {
              return (
                <Tab
                  className="tabList"
                  label={tabItem?.name}
                  key={i}
                  {...a11yProps(i, tabItem?.id)}
                />
              );
            })}
            {canViewAiDashboard && (
              <Tab
                className="tabList"
                label="AI-Dashboard"
                {...a11yProps(REPORT_DASHBOARD_TAB_INDEX, "reportDashboardTab")}
              />
            )}
          </Tabs>
        </Grid>

        <Grid item md={12} xs={12} mt={3}>
          <TabPanel value={value} index={0}>
            <InspectionsContainer tab={value} />
          </TabPanel>
          <TabPanel value={value} xs={12} index={1}>
            <LmsContainer tab={value} />
          </TabPanel>
          <TabPanel value={value} xs={12} index={2}>
            <IncidentsContainer tab={value} />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};

export default ReportAnalytics;
